import { modifierGroupRuleAdapter, priceVariantsAdapter } from './adapters';
import { createFieldToEntityMap } from './common';
import { cleanDoubleAndTrailingSpace } from './modifiers';
export const convertDisplayedPriceVariantsToPriceVariantsDTO = priceVariants => {
  return priceVariants.map(priceVariant => ({
    ...(priceVariant.id && {
      id: priceVariant.id
    }),
    ...(priceVariant.revision && {
      revision: priceVariant.revision
    }),
    name: cleanDoubleAndTrailingSpace(priceVariant.name)
  }));
};
export const convertDisplayedPriceVariantsToPriceVariantsInItem = priceVariants => {
  return priceVariants.map(priceVariant => {
    var _priceVariant$priceIn;
    return {
      variantId: priceVariant.id,
      priceInfo: {
        price: (_priceVariant$priceIn = priceVariant.priceInfo) == null ? void 0 : _priceVariant$priceIn.price
      }
    };
  });
};
export const convertPopulatedModifierGroupsToModifierGroupsInItem = modifierGroups => {
  return modifierGroups.map(modifierGroup => ({
    id: modifierGroup.id
  }));
};
export const convertDisplayedLabelsToLabelsInItem = labels => {
  return labels.map(label => ({
    id: label.id
  }));
};
export const convertPopulatedItemToItemDTO = (item, isPriceVariantsToggled, populationLevel) => {
  const {
    priceVariants,
    modifierGroups,
    labels,
    ...itemWithoutPopulatedEntities
  } = item;
  let itemDTO = {
    ...itemWithoutPopulatedEntities,
    ...(item.labels && {
      labels: populationLevel != null && populationLevel.labels ? convertDisplayedLabelsToLabelsInItem(item.labels) : item.labels
    }),
    ...(item.modifierGroups && {
      modifierGroups: populationLevel != null && populationLevel.modifierGroups ? convertPopulatedModifierGroupsToModifierGroupsInItem(item.modifierGroups) : item.modifierGroups
    }),
    ...(item.orderSettings && {
      orderSettings: {
        acceptSpecialRequests: item.orderSettings.acceptSpecialRequests,
        inStock: item.orderSettings.inStock,
        taxGroupId: item.orderSettings.taxGroupId
      }
    })
  };
  if (isPriceVariantsToggled) {
    var _item$priceVariants;
    itemDTO = {
      ...itemDTO,
      ...(((_item$priceVariants = item.priceVariants) == null ? void 0 : _item$priceVariants.variants) && {
        priceVariants: {
          variants: populationLevel != null && populationLevel.priceVariants ? convertDisplayedPriceVariantsToPriceVariantsInItem(item.priceVariants.variants) : priceVariantsAdapter(item.priceVariants.variants)
        }
      }),
      // @ts-expect-error
      priceInfo: {
        price: null
      }
    };
  } else {
    var _item$priceInfo;
    itemDTO = {
      ...itemDTO,
      // @ts-expect-error
      priceVariants: null,
      priceInfo: {
        price: (_item$priceInfo = item.priceInfo) == null ? void 0 : _item$priceInfo.price
      }
    };
  }
  return itemDTO;
};
export const convertItemDTOToPopulatedItem = (item, itemModifierGroups, itemPriceVariants, itemLabels, populationLevel) => {
  const priceVariants = populationLevel != null && populationLevel.priceVariants ? itemPriceVariants : itemPriceVariants == null ? void 0 : itemPriceVariants.map(priceVariant => ({
    variantId: priceVariant.variantId,
    priceInfo: priceVariant.priceInfo
  }));
  return {
    id: item.id,
    revision: item.revision,
    name: item.name,
    description: item.description,
    featured: item.featured,
    ...(item.priceInfo && {
      priceInfo: item.priceInfo
    }),
    ...(item.priceVariants && {
      priceVariants: {
        variants: priceVariants
      }
    }),
    image: item.image,
    additionalImages: item.additionalImages,
    ...(item.modifierGroups && {
      modifierGroups: itemModifierGroups
    }),
    ...(item.labels && {
      labels: itemLabels
    }),
    ...(item.orderSettings && {
      orderSettings: {
        acceptSpecialRequests: item.orderSettings.acceptSpecialRequests,
        inStock: item.orderSettings.inStock,
        taxGroupId: item.orderSettings.taxGroupId
      }
    }),
    visible: item.visible,
    createdDate: item.createdDate,
    ...(item.businessLocationIds && {
      businessLocationIds: item.businessLocationIds
    })
  };
};
export const convertDisplayedModifiersToModifiersDTO = modifiers => {
  return modifiers.map(modifier => ({
    ...(modifier.id && {
      id: modifier.id
    }),
    ...(modifier.revision && {
      revision: modifier.revision
    }),
    name: cleanDoubleAndTrailingSpace(modifier.name),
    inStock: modifier.inStock ?? true
  }));
};
export const convertModifiersInModifierGroupToDisplayedModifier = (modifiers, createdModifiers) => {
  const idsToModifiersMap = createFieldToEntityMap(createdModifiers, 'id');
  return modifiers.reduce((acc, modifier) => {
    const displayedModifier = {
      ...idsToModifiersMap[modifier.id],
      preSelected: modifier.preSelected,
      additionalChargeInfo: modifier.additionalChargeInfo
    };
    acc = acc.concat(displayedModifier);
    return acc;
  }, []);
};
export const convertDisplayedModifiersToModifiersInModifierGroup = displayedModifiers => {
  return displayedModifiers.reduce((acc, displayedModifier) => {
    acc = acc.concat({
      id: displayedModifier.id,
      additionalChargeInfo: displayedModifier.additionalChargeInfo,
      preSelected: displayedModifier.preSelected
    });
    return acc;
  }, []);
};
export const convertPopulatedModifierGroupsToModifierGroupsDTO = modifierGroups => {
  return modifierGroups.map(modifierGroup => {
    return {
      ...(modifierGroup.id && {
        id: modifierGroup.id
      }),
      ...(modifierGroup.revision && {
        revision: modifierGroup.revision
      }),
      ...(modifierGroup.createdDate && {
        createdDate: modifierGroup.createdDate
      }),
      ...(modifierGroup.businessLocationIds && {
        businessLocationIds: modifierGroup.businessLocationIds
      }),
      name: modifierGroup.name,
      rule: modifierGroupRuleAdapter(modifierGroup.rule),
      modifiers: convertDisplayedModifiersToModifiersInModifierGroup(modifierGroup.modifiers)
    };
  });
};
//# sourceMappingURL=converters.js.map